import { createGlobalStyle } from 'styled-components';

import { COLORS } from 'theme/palette';

export const GlobalStyle = createGlobalStyle`
    html {
        font-size: 62.5%;
    }

    html, body {
        min-height: 100vh;
    }

    &:focus-visible {
        outline: 2px solid ${COLORS.focus};
    }

    #root {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    /* Hide react-medium-image-zoom buttons from overlay */
    [data-rmiz-btn-zoom],
    [data-rmiz-btn-unzoom] {
        opacity: 0
    }
`;
